import * as React from "react";

import { AbsoluteCircle } from "../AHTheme/Circle";
import { NumberIconSvg } from "./NumberIcon";

export const NumberTaskIcon = (props: {
  color?: string;
  absoluteSize: number;
}) => {
  return (
    <AbsoluteCircle
      absoluteSize={props.absoluteSize}
      borderWidth={2}
      style={{
        borderColor: props.color,
      }}
    >
      <NumberIconSvg color={props.color} />
    </AbsoluteCircle>
  );
};
